import DateLabel from './DateLabel'

export default DateLabel
